export default "__VITE_ASSET__ByRgP38T__"